import { gql } from 'gql/__generated__'

export const updateUserPreferences = gql(`
  mutation updatePreferences($data: JSON!) {
    data: updatePreferences(preferences: $data) {
      ...kUserInfoSchema
    }
  }
`)
